
import { defineComponent, ref, computed } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'CountriesModal',
  props: {
    currentCountry: {
      type: Object,
      default: () => {},
    },
    countries: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const modal = ref(null);

    const isOpenModal = computed(() => {
      if (!modal.value) return false;

      return modal.value.isOpen;
    });

    return {
      modal,
      isOpenModal,
    };
  },
});
